import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library'; 

import Profile from '../components/Profile';
import BulkProfile from '../components/BulkProfile';
import Confirm from '../../../components/AppCart/GenericApps/Confirm/Confirm';
import Survey from '../../../components/UI/Survey/Survey';
import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';

const SubmissionSummary = props => {
	return (
		<Fragment>
			<section
				className={utils.concatenateClassNames(
					'edit-container',
					classes
				)}
			>
				{props.profile ? (
					<section>
						<Profile details={props.profile} navigation={false} />
					</section>
				) : (
					<section>
						<BulkProfile />
					</section>
				)}

				<Confirm
					actionButtons={
						<Link
							to={{
								pathname: '/UserAccessReview/Dashboard',
							}}
						>
							<Button variant='outlined'>Return to Dashboard</Button>
						</Link>
					}
				>
					{props.children}
				</Confirm>
			</section>
			<Survey
				href='https://forms.office.com/Pages/ResponsePage.aspx?id=Ptc9i3JOeUaxkVbaFYhxK866Z4dGGb9PsWQoeDcGccJURUdQVk9ISTZROVpRMlJNOVdWUDZQTVoxUS4u'
				intrusive={false}
				target='User Access Review'
			/>
		</Fragment>
	);
};

export default SubmissionSummary;
